<template>
  <v-content>

    <DetailsDialog ref="detailsDialog"/>

    <v-container fluid>
      <v-layout>
        <v-flex>

          <OLoadingDialog :value="isLoading"/>

          <v-card>
            <v-toolbar flat class="card-bar">
              <v-toolbar-title>SIM Cards</v-toolbar-title>

              <v-btn icon @click="reload" class="ml-2">
                <v-icon>refresh</v-icon>
              </v-btn>

              <v-spacer/>

              <v-text-field v-model="txtFilter" class="pa-0"
                append-icon="search"
                label="Filtro por id ou linha..."
                single-line hide-details/>
            </v-toolbar>

            <ODataTable
              :items="filteredRows"
              :spec="spec"
              @rowClicked="showDetailsDialog"/>

          </v-card>

        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import _ from 'lodash'
import {SimCard} from '@/models'
import DetailsDialog from './DetailsDialog.vue'
import OLoadingDialog from 'oderon-vue/cpts/OLoadingDialog'
import ODataTable from 'oderon-vue/cpts/ODataTable'
import {matchAny} from '@/utils'
import {iso, brYesNo} from 'oderon-commons/src/formatters'

export default {
  components: {DetailsDialog, OLoadingDialog, ODataTable},
  data() {
    return {
      isLoading: false,
      txtFilter: '',
      rows: [],
      selectedRow: null,
      spec: [
        {t: 'ICCID|'      , d: 'iccid'},
        {t: 'Num. Linha|' , d: 'phoneNumber'},
        {t: 'Veículo|'    , d: row => {
          if ( row.first == null ) return '-'
          let org   = row.first.organization.name,
              vcode = row.first.vehicleCode
          return `${org} - ${vcode || '(sem placa)'}`
        }},
        {t: '', code: 'clientCount', d: row => {
          if ( row.clients == null || row.clients.length < 2 ) return ''
          return {labelColor: 'red', labelText: '+' + (row.clients.length-1)}
        }},
        {t: 'Operadora|'  , d: 'operator'},
        {t: 'Pré-Pago?|'  , d: 'isPrePaid', f: brYesNo},
        {t: 'APN?|'       , d: 'isApn', f: brYesNo},
        {t: 'Comentários' , d: 'comments'},
        {t: 'Última Transmissão', d: 'lastHbTimestamp', f: iso}
      ]
    }
  },
  computed: {
    filteredRows() {
      return _.filter(this.rows, r => {
        let orgNames = _.map(r.clients, 'organization.name'),
            vcodes   = _.map(r.clients, 'vehicleCode')

        return matchAny(this.txtFilter, r.iccid, r.phoneNumber,
          r.operator, r.comments, orgNames, vcodes)
      })
    }
  },
  mounted() { this.reload() },
  methods: {
    reload() { this.$loading(() => this.fetchData()) },

    async fetchData() {
      let rows = await SimCard.findAll()
      rows.forEach(r => r.first = _.get(r, 'clients[0]'))
      this.rows = rows
    },

    // save(obj) {
    //   this.selectedRow = null
    //   this.$loading(async () => {
    //     await SimCard.save(obj)
    //     await this.fetchData()
    //   })
    // },

    async showDetailsDialog(row) {
      let dialog = this.$refs.detailsDialog,
          res = await dialog.open(row.id)

      if ( res != null ) {
        this.$loading(async () => {
          await SimCard.save(res)
          await this.fetchData()
        })
      }
    }
  }
}

</script>

<style>
</style>
